export interface InspectionFilterSettings {
  start: string;
  end: string;
  min: string;
  max: string;
};

export interface InspectionsSettings {
  conductedFromDate: number;
  conductedToDate: number;
  inspectionDateMax: number;
  inspectionDateMin: number;
};


interface SentrySettings {
  enable: boolean;
  enableBrowserTracingIntegration: boolean;
  enableReplayIntegration: boolean;
}
interface LoginSettings {
  clientId: string;
  url: string;
  issuer: string;
}
interface QcInspectionSettings {
  autoCloseInspection: boolean;
}
interface DefectSettings {
  isDefectImageRequired: boolean;
}

interface SizeCheckConfig {
  passes: number;
  decimalPlaces: number;
  passesTitles: string[];
}
/** Stable key names for optional config – use these instead of string literals. */
export const APP_CONFIG_KEY = {
  apiUploadLocations: 'api-upload-locations',
  useText: 'use-text',
  defaultDivision: 'default-division',
  showAssignedLocationInspections: 'show-assigned-location-inspections',
  mandatoryGpsLocation: 'mandatory-gps-location',
  mandatoryFactoryLocationVerification: 'mandatory-factory-location-verification',
  startInspectionCheck: 'start-inspection-check',
  showInternalOrderRef: 'show-internal-order-ref',
  recordDefect: 'record-defect',
  inspectorCommentLength: 'inspector-comment-length',
  sizeCheck: 'size-check',
  showFactory: 'show-factory',
} as const;

/** Optional app config flags and lists (kebab-case keys from API). */
interface AppConfigKeys {
  [APP_CONFIG_KEY.apiUploadLocations]?: string[];
  [APP_CONFIG_KEY.useText]?: string;
  [APP_CONFIG_KEY.defaultDivision]?: string;
  [APP_CONFIG_KEY.showAssignedLocationInspections]?: boolean;
  [APP_CONFIG_KEY.mandatoryGpsLocation]?: boolean;
  [APP_CONFIG_KEY.mandatoryFactoryLocationVerification]?: boolean;
  [APP_CONFIG_KEY.startInspectionCheck]?: boolean;
  [APP_CONFIG_KEY.showInternalOrderRef]?: boolean;
  [APP_CONFIG_KEY.showFactory]?: boolean;
}



export type AppConfigKey = keyof typeof APP_CONFIG_KEY;

export interface AppConfig extends AppConfigKeys {
  sk: string;
  sentry?: SentrySettings;
  inspections?: InspectionsSettings;
  login: LoginSettings;
  qcInspection: QcInspectionSettings;
  [APP_CONFIG_KEY.recordDefect]: DefectSettings;
  [APP_CONFIG_KEY.inspectorCommentLength]: number;
  [APP_CONFIG_KEY.sizeCheck]: SizeCheckConfig;
  filters?: string[];
}